import { render, staticRenderFns } from "./AQLQ.vue?vue&type=template&id=673245a8&scoped=true&lang=pug&"
import script from "./AQLQ.vue?vue&type=script&lang=js&"
export * from "./AQLQ.vue?vue&type=script&lang=js&"
import style0 from "./AQLQ.vue?vue&type=style&index=0&id=673245a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673245a8",
  null
  
)

export default component.exports